module.exports = __webpack_public_path__ + "static/media/title.552fa79d.png";